const getToken = () => {
  try {
    const name = "_token_avaex_agent=";
    const indexStart = document.cookie.indexOf(name);
    const string = document.cookie.slice(indexStart);
    const indexEnd = string.indexOf(";");

    return string.slice(name.length, indexEnd === -1 ? undefined : indexEnd);
  } catch (error) {
    return undefined;
  }
};

export default getToken;
